import { DepositModel, TransactionsDepositSearch } from "../../../models/dashboard/transactions/transation";
import { adminHttpClient } from "../../../commons/adminHttpClinet"


const getTransactionDepositByTransfer = (model:TransactionsDepositSearch) : Promise<DepositModel> => {
    return adminHttpClient.get(`/api/Admin/AdminTransactions/get-transaction-deposit?SearchValue=${model.searchValue}&PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&OrderDescending=${model.orderDescending}&TransferId=${model.transferId}&UserId=${model.userId}`)
}

export default getTransactionDepositByTransfer;
